module.exports = __webpack_public_path__ + "img/icon-sb-shop-more-tablet.534aa12.svg";